import { createApi } from '@reduxjs/toolkit/dist/query/react';

import serverRoutes from '@app/utils/server-routes';

import { baseQuery } from '@app/store/baseQuery';
import {
  QmCommandCreateType,
  QmCommandsListType,
  QmCommandsOperatorsList,
} from '@app/interfaces/qm-module/qm-manage/qm-commands.type';

export const qmManageCommandsApi = createApi({
  reducerPath: 'qmManageCommandsApi',
  tagTypes: ['qm_commands_list', 'qm_command', 'operators_list'],
  baseQuery: baseQuery,
  endpoints: (build) => ({
    getCommandsBulk: build.query<{ qm_teams: QmCommandsListType[] }, void>({
      query: () => ({
        url: serverRoutes.qm_manage_commands_bulk,
      }),
      providesTags: ['qm_commands_list'],
    }),
    getSingleCommand: build.query<QmCommandsListType, { team_id: string }>({
      query: (params) => ({
        url: serverRoutes.qm_manage_commands,
        params,
      }),
      providesTags: ['qm_command'],
    }),
    createCommand: build.mutation<QmCommandsListType, QmCommandCreateType>({
      query: (body) => ({
        url: serverRoutes.qm_manage_commands,
        body,
        method: 'POST',
      }),
      invalidatesTags: ['qm_commands_list'],
    }),
    editCommand: build.mutation<
      QmCommandsListType,
      { params: { team_id: string }; body: QmCommandCreateType }
    >({
      query: ({ body, params }) => ({
        url: serverRoutes.qm_manage_commands,
        body,
        params,
        method: 'PUT',
      }),
      invalidatesTags: ['qm_commands_list', 'qm_command'],
    }),
    changeCommandStatus: build.mutation<
      QmCommandsListType,
      { params: { team_id: string }; body: { status: 'active' | 'disbanded' } }
    >({
      query: ({ params, body }) => ({
        url: serverRoutes.qm_manage_commands_status,
        params,
        body,
        method: 'PUT',
      }),
      invalidatesTags: ['qm_commands_list'],
    }),
    //operators
    getCommandOperatorsList: build.query<QmCommandsOperatorsList, { team_id: string }>({
      query: (params) => ({
        url: serverRoutes.qm_manage_commands_operator_bulk,
        params,
      }),
      providesTags: ['operators_list'],
    }),
    addOperatorToCommand: build.mutation<
      QmCommandsOperatorsList,
      { team_id: string; user_id: string }
    >({
      query: ({ user_id, team_id }) => ({
        url: serverRoutes.qm_manage_commands_operator,
        body: { user_id },
        params: { team_id },
        method: 'POST',
      }),
      invalidatesTags: ['operators_list'],
    }),
    removeOperatorFromCommand: build.mutation<
      QmCommandsOperatorsList,
      { team_id: string; item_id: string }
    >({
      query: (params) => ({
        url: serverRoutes.qm_manage_commands_operator,
        params,
        method: 'DELETE',
      }),
      invalidatesTags: ['operators_list'],
    }),
  }),
});
// qm/team/operator/bulk

export const {
  useGetCommandsBulkQuery,
  useLazyGetSingleCommandQuery,
  useCreateCommandMutation,
  useEditCommandMutation,
  useChangeCommandStatusMutation,

  useLazyGetCommandOperatorsListQuery,
  useGetCommandOperatorsListQuery,
  useAddOperatorToCommandMutation,
  useRemoveOperatorFromCommandMutation,
} = qmManageCommandsApi;
